import axios from "@/axios";

export default {
    tariff: {
        create(payload) {
            return axios.post('payments/tariffs', payload);
        }
    },
    rent: {
        create(payload) {
            return axios.post('payments/rents', payload);
        }
    },
}